import { createInjectable } from "ngxtension/create-injectable";
import {
  HttpClient,
  HttpContext,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { AUTH_DAVESA_API, SKIP_LOADING } from "app/core/auth-davesa/auth-davesa-api.component";

const httpOptions = {
  context: new HttpContext().set(AUTH_DAVESA_API, true),
};

function getNotificationRequestOptions(skipLoading?: boolean): { context: HttpContext } {
  const context = new HttpContext().set(AUTH_DAVESA_API, true);
  if (skipLoading) {
    context.set(SKIP_LOADING, true);
  }
  return { context };
}

export const NotificationsV2ApiService = createInjectable(() => {
  const _httpClient = inject(HttpClient);

//Notifications API Service
  const getFullNotifications = async (params: any):Promise<any> => {
    const response$ = _httpClient.post<any>('notification/full', params, httpOptions);
    const response: any = await firstValueFrom(response$)
    return response.data;
  };

  const getAllNotifications = async (params: any, options?: { skipLoading?: boolean }): Promise<any> => {
    const opts = getNotificationRequestOptions(options?.skipLoading);
    const response$ = _httpClient.post<any>('notification', params, opts);
    const response: any = await firstValueFrom(response$);
    return response;
  };

  const updateNotificationInfo = async (data: any):Promise<any> => {
    const response$ = _httpClient.put<any>('notification/update', data, httpOptions);
    const response: any = await firstValueFrom(response$)
    return response.data;
  };

  const markAllAsReadNotification = async ():Promise<any> => {
    const response$ = _httpClient.get<any>('notification/mark-all-as-read', httpOptions);
    const response: any = await firstValueFrom(response$)
    return response.data;
  };

  const notificationCategories = async (params: any):Promise<any> => {
    const response$ = _httpClient.post<any>('admin/notification-category', params, httpOptions);
    const response: any = await firstValueFrom(response$)
    return response.data;
  };

  const notificationForEisf = async (userList: any):Promise<any> => {
    const response$ = _httpClient.post<any>('admin/notification-category', userList, httpOptions);
    const response: any = await firstValueFrom(response$)
    return response.data;
  };

  
  return {
  getAllNotifications,
  updateNotificationInfo,
  markAllAsReadNotification,
  notificationCategories,
  notificationForEisf,
  getFullNotifications
};
});
